import { render } from "./ListsPage.vue?vue&type=template&id=7250471c&scoped=true"
import script from "./ListsPage.vue?vue&type=script&lang=js"
export * from "./ListsPage.vue?vue&type=script&lang=js"

import "./ListsPage.vue?vue&type=style&index=0&id=7250471c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7250471c"]])

export default __exports__